import { Spacer } from "@aviary";
import {
  SignUpModalHeader,
  SignUpModalTitle,
  StoreLandingLayout,
  StoreLogo,
  StoreOffersPill,
} from "@unauthenticated/signupSignin/components";
import type { PatientAttributes } from "@unauthenticated/signupSignin/data/types";

import { EmailCheckForm } from "./EmailCheckForm";

interface Props {
  patientAttributes: PatientAttributes;
  additionalAttributes?: any;
  ssoErrors?: string;
  storeId?: string;
  isPreview?: boolean;
  isStoreOwner: boolean;
}

const PatientAuthStartPage = ({
  patientAttributes,
  additionalAttributes,
  ssoErrors,
  storeId,
  isPreview = false,
  isStoreOwner,
}: Props) => {
  const { storeLogo, storeName, pracName, pracAvatar } = patientAttributes;

  return (
    <StoreLandingLayout
      pracName={pracName}
      pracAvatar={pracAvatar}
      isPreview={isPreview}
      isStoreOwner={isStoreOwner}
    >
      <SignUpModalHeader>
        <StoreLogo storeLogo={storeLogo} storeName={storeName} />
        <SignUpModalTitle title={storeName} />
        <StoreOffersPill patientAttributes={patientAttributes} />
      </SignUpModalHeader>
      <Spacer height="double" />
      <EmailCheckForm
        patientAttributes={patientAttributes}
        additionalAttributes={additionalAttributes}
        ssoErrors={ssoErrors}
        storeId={storeId}
        isPreview={isPreview}
      />
    </StoreLandingLayout>
  );
};

export { PatientAuthStartPage };
